export const RELAYER_REGISTRATION_PATHS = {
  base: '/relayer-registration',
  requirements: '/relayer-registration/requirements',
  relayerUrl: '/relayer-registration/relayer-url',
  ensIdentifier: '/relayer-registration/ens-identifier',
  workers: '/relayer-registration/workers',
  review: '/relayer-registration/review',
} as const;

export const RELAYER_REGISTRATION_STEPS = [
  { number: 1, label: 'Requirements', path: RELAYER_REGISTRATION_PATHS.requirements },
  { number: 2, label: 'Relayer URL', path: RELAYER_REGISTRATION_PATHS.relayerUrl },
  { number: 3, label: 'ENS / identifier', path: RELAYER_REGISTRATION_PATHS.ensIdentifier },
  { number: 4, label: 'Workers', path: RELAYER_REGISTRATION_PATHS.workers },
  { number: 5, label: 'Review & register', path: RELAYER_REGISTRATION_PATHS.review },
] as const;
